import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';

const selectPlaybookTrackerState = (state: RootState) => state.playbookTracker;

export const getPlaybookTrackerLoading = (state: RootState) =>
  selectPlaybookTrackerState(state).loading;

export const getPlaybookTrackerError = (state: RootState) =>
  selectPlaybookTrackerState(state).error;

export const getPlaybookTrackerRows = (state: RootState) =>
  selectPlaybookTrackerState(state).rows;

export const getPlaybookTrackerTotal = (state: RootState) =>
  selectPlaybookTrackerState(state).total;

export const getPlaybookTrackerFilterOptions = (state: RootState) =>
  selectPlaybookTrackerState(state).filterOptions;

// ⚡ memoized selector (optional optimization)
export const getPlaybookTrackerSummary = createSelector(
  selectPlaybookTrackerState,
  (state) => ({
    loading: state.loading,
    error: state.error,
    total: state.total,
    count: state.rows.length,
  }),
);
